<template>
  <page>
    <list-table group="entrant" />
  </page>
</template>

<script>
import Page from "../../components/Page";
import ListTable from "../../components/group-management/ListTable";

export default {
  name: "UsersGroupList",
  components: { ListTable, Page }
};
</script>

<style scoped></style>
